import { User } from "pages/user-management/UserType";
import axiosClient from "./axios";

export const login = async (username: string, password: string) => {
  const response = await axiosClient.post('/auth/login', { username, password });
  return response.data;
};

export const changePassword = async (oldPassword: string, newPassword: string) => {
  const response = await axiosClient.post(`/auth/change-password`, { oldPassword, newPassword });
  return response.data;
};

// API function to fetch users
export const fetchUsers = async (page: number, pageSize: number): Promise<{records: User[], total: number}> => {
    const response = await axiosClient.get('/user/all', {
        params: {
            page: page + 1,
            pageSize
        }
    });
    return response.data;
};

export const resetPassword = async (userId: number) => {
  const response = await axiosClient.post(`/user/${userId}/reset-password`);
  return response.data;
};

export const disableUser = async (userId: number) => {
  await axiosClient.patch(`/user/${userId}/disable`);
};

export const enableUser = async (userId: number) => {
  await axiosClient.patch(`/user/${userId}/enable`);
};